const API_KEY = "50ef43829772a9b2eb3906f67304f73a";

const requests = {
    getTrending: `/trending/all/week?api_key=${API_KEY}&language=en-US`,
    getNetflixOriginals: `/discover/tv?api_key=${API_KEY}&with_networks=213`,
    getTopRatedMovies: `/movie/top_rated?api_key=${API_KEY}&languages=en-US`,
    getActionMovies: `/discover/movie?api_key=${API_KEY}&with_genres=28`,
    getComedyMovies: `/discover/movie?api_key=${API_KEY}&with_genres=35`,
    getHorrorMovies: `/discover/movie?api_key=${API_KEY}&with_genres=27`,
    getRomanticMovies: `/discover/movie?api_key=${API_KEY}&with_genres=10749`,
    getDocs: `/discover/movie?api_key=${API_KEY}&with_genres=99`,
};

export default requests;
